$(document).ready(function(){
    var top = $('header').height();

    $(window).scroll(function(){
        if($(window).scrollTop() > top){
			$('.navbar').addClass('navbar-fixed-top');
            $('header').addClass('sticky');
		}else{
			$('.navbar').removeClass('navbar-fixed-top');
            $('header').removeClass('sticky');
		}
    })
    $('.search-toggle').on('click',function() {
    	$(".search-box-wrapper").toggleClass("active")
  	});
  
  $(window).on('load resize', function(){ 
        var width = $(window).width();
        if(width < 991){
            var count = $('.mobile-cart.list-inline').length;
            if(count < 1){
                $('li.search-basket').wrapAll("<ul class='mobile-cart list-inline'></ul>");
                $('.mobile-cart').insertAfter('.navbar-brand');  
            }                
        }else{
            $('li.search-basket').unwrap("<ul class='mobile-cart list-inline'></ul>");
            $('li.search-basket').appendTo(".navigation-right ul");
        }
    });
  
  $('.banner-icon').click(function(){
  	var icon_title = $(this).attr('data-icon-title');
    $('.icon-li').removeClass('active');
    $(this).parent().addClass('active');
    $('.banner-icon-content').addClass('hide');
    $('.icon-content'+ icon_title).removeClass('hide');
  })
})